import { motion } from "framer-motion";
import { DISCORD_URL } from "../guides/parts";
import { type Review, REVIEWS_SOURCE, reviewDate } from "../data/reviews";

/* One review as it was posted: the words, who posted them and when. No stars
   -- nobody gave any. */
export function ReviewCard({ review, index = 0 }: { review: Review; index?: number }) {
  return (
    <motion.figure
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.5, delay: (index % 3) * 0.06 }}
      className="mb-4 break-inside-avoid rounded-2xl border border-white/8 bg-ground-2 p-5"
    >
      <blockquote className="text-[0.95rem] leading-relaxed text-white/80">“{review.text}”</blockquote>
      <figcaption className="mt-4 flex items-center gap-3 text-sm">
        <span
          aria-hidden
          className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-primary/15 text-xs font-bold uppercase text-primary-light"
        >
          {review.author.slice(0, 1)}
        </span>
        <span className="min-w-0">
          <span className="block truncate font-semibold text-white">{review.author}</span>
          <time dateTime={review.date} className="block text-xs text-white/40">
            {reviewDate(review.date)} · Discord
          </time>
        </span>
      </figcaption>
    </motion.figure>
  );
}

/** Where the quotes come from, with the way to read the rest. */
export function ReviewsSourceNote() {
  return (
    <p className="text-sm text-white/45">
      Posted by customers in {REVIEWS_SOURCE}.{" "}
      <a href={DISCORD_URL} target="_blank" rel="noopener noreferrer" className="text-primary-light hover:text-white">
        Read them all there →
      </a>
    </p>
  );
}

export function ReviewsGrid({ reviews }: { reviews: Review[] }) {
  return (
    <div className="columns-1 gap-4 md:columns-2 lg:columns-3">
      {reviews.map((r, i) => (
        <ReviewCard key={`${r.author}-${r.date}`} review={r} index={i} />
      ))}
    </div>
  );
}
